import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import ContactTitleShow from './contact-title-show';
import ContactTitleForm from './contact-title-form';

function ContactTitlePage() {
  const navigate = useNavigate();
  const {titleId} = useParams();
  const isNew = titleId === 'new';
  const [mode, setMode] = useState(isNew ? 'edit' : 'show');
  // Used to force-remount ContactTitleShow after a successful save so it refetches.
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!isNew) setMode('show');
  }, [titleId, isNew]);

  const goToList = () => navigate('/contacts/titles');

  if (isNew) {
    return (
      <ContactTitleForm
        titleId="new"
        onCancel={goToList}
        onSaved={(saved) => {
          if (saved?.id) navigate(`/contacts/titles/${saved.id}`);
          else goToList();
        }}
      />
    );
  }

  if (mode === 'show') {
    return (
      <ContactTitleShow
        key={`show-${reloadKey}`}
        titleId={titleId}
        onEdit={() => setMode('edit')}
        onList={goToList}
      />
    );
  }

  return (
    <ContactTitleForm
      titleId={titleId}
      onCancel={() => setMode('show')}
      onSaved={() => {
        setReloadKey((k) => k + 1);
        setMode('show');
      }}
    />
  );
}

export default ContactTitlePage;
